import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme: any) => ({
  unknownScreen: {
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  wrapper: {
    display:'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    minHeight: '80vh',
    flexDirection: 'column'
  },
  error: {
    fontSize: '50px',
    color: theme.palette.text.secondary,
    paddingBottom: '50px'
  },
  label: {
    fontSize: '60px',
    color: theme.palette.primary.main,
    paddingBottom: '60px',
    fontWeight: 600,
  },
  link: {
    fontSize: '20px',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontWeight: 500,
    textDecoration: 'underline'
  },
}));

export default useStyles;
